import { useQuery } from '@tanstack/react-query'

import { exists } from '~/utils'

import { useSurveyBrandAccountQueryFn } from './useSurveyBrandAccountQueryFn'
import { useSurveyBrandAccountQueryKey } from './useSurveyBrandAccountQueryKey'

export const useSurveyBrandAccountQuery = (surveyId: string | undefined) => {
  const queryFn = useSurveyBrandAccountQueryFn(surveyId)
  const queryKey = useSurveyBrandAccountQueryKey(surveyId)

  return useQuery({
    queryFn,
    queryKey,
    staleTime: Infinity,
    enabled: exists(surveyId),
  })
}
